// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start; /* Alinea los elementos al principio */
  margin-bottom: 20px;
}

.upload-container {
  display: flex;
  gap: 10px; /* Espaciado entre los botones */
}

.pedido-details {
  flex-grow: 1; /* Permite que ocupe el espacio necesario */
  display: flex;
  justify-content: flex-end; /* Alinea los detalles hacia la derecha */
}

.pedido-card {
  max-width: 300px;
  text-align: left;
  padding: 10px;
  background-color: #f8f9fa; /* Fondo claro para destacar */
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.pedido-details-horizontal {
  display: flex;
  justify-content: space-between;
  align-items: center; /* Alinea los elementos verticalmente */
  padding: 10px 15px;
  margin-bottom: 20px;
  background-color: #f8f9fa; /* Fondo claro */
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  flex-wrap: wrap; /* Permite que se ajusten en pantallas pequeñas */
}

.pedido-info {
  margin-right: 20px; /* Espaciado entre los bloques de información */
  text-align: left;
  font-size: 14px;
}

.tipos-mcia-list {
  margin: 0;
  padding: 0;
  list-style-type: none; /* Sin viñetas para la lista */
}

.tipos-mcia-list li {
  display: inline;
  margin-right: 10px; /* Espacio entre elementos */
}

/* --- Estilos Premium para Tabla de Historial --- */

/* Permitir que los encabezados tengan varias líneas y centrar texto */
.table-historico-nested .p-datatable .p-datatable-thead > tr > th {
  white-space: normal !important;
  text-align: center !important;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
  padding: 8px 4px !important;
  background: #f1f3f5 !important;
  color: #495057;
  border-bottom: 2px solid #dee2e6;
  vertical-align: middle;
}

/* Estilo de celdas internas */
.table-historico-nested .p-datatable .p-datatable-tbody > tr > td {
  font-size: 12px;
  padding: 6px 4px !important;
  text-align: center;
  white-space: nowrap; /* Evita que el contenido se amontone */
  overflow: hidden;
  text-overflow: ellipsis;
}

.nested-table-title {
  margin-bottom: 12px;
  color: #2c3e50;
  font-weight: 600;
  border-left: 4px solid #3498db;
  padding-left: 10px;
}

.table-historico-nested {
  background: #ffffff;
  border-radius: 6px;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
  padding: 15px !important;
  margin: 10px 0;
}

/* Forzar que la tabla ocupe el espacio restante */
.full-height-table {
  display: flex;
  flex-direction: column;
  height: 100%; /* Asegura ocupar el contenedor flex asignado */
}

/* Forzar que el wrapper (área de scroll) crezca */
.full-height-table .p-datatable-wrapper {
  flex-grow: 1;
  height: auto !important; /* Sobrescribir estilos inline si es necesario */
}

/* Asegurar que el footer del diálogo no se colapse */
.p-dialog-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/styles/EditarListaDeEmpaqueModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB,EAAE,sCAAsC;EAC/D,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS,EAAE,gCAAgC;AAC7C;;AAEA;EACE,YAAY,EAAE,2CAA2C;EACzD,aAAa;EACb,yBAAyB,EAAE,yCAAyC;AACtE;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,yBAAyB,EAAE,8BAA8B;EACzD,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB,EAAE,uCAAuC;EAC5D,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB,EAAE,gBAAgB;EAC3C,kBAAkB;EAClB,wCAAwC;EACxC,eAAe,EAAE,iDAAiD;AACpE;;AAEA;EACE,kBAAkB,EAAE,+CAA+C;EACnE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,qBAAqB,EAAE,8BAA8B;AACvD;;AAEA;EACE,eAAe;EACf,kBAAkB,EAAE,4BAA4B;AAClD;;AAEA,oDAAoD;;AAEpD,sEAAsE;AACtE;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,8BAA8B;EAC9B,cAAc;EACd,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB,EAAE,uCAAuC;EAC5D,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;EAC/C,wBAAwB;EACxB,cAAc;AAChB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAE,+CAA+C;AAC/D;;AAEA,kDAAkD;AAClD;EACE,YAAY;EACZ,uBAAuB,EAAE,gDAAgD;AAC3E;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd","sourcesContent":[".header-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start; /* Alinea los elementos al principio */\n  margin-bottom: 20px;\n}\n\n.upload-container {\n  display: flex;\n  gap: 10px; /* Espaciado entre los botones */\n}\n\n.pedido-details {\n  flex-grow: 1; /* Permite que ocupe el espacio necesario */\n  display: flex;\n  justify-content: flex-end; /* Alinea los detalles hacia la derecha */\n}\n\n.pedido-card {\n  max-width: 300px;\n  text-align: left;\n  padding: 10px;\n  background-color: #f8f9fa; /* Fondo claro para destacar */\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.pedido-details-horizontal {\n  display: flex;\n  justify-content: space-between;\n  align-items: center; /* Alinea los elementos verticalmente */\n  padding: 10px 15px;\n  margin-bottom: 20px;\n  background-color: #f8f9fa; /* Fondo claro */\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  flex-wrap: wrap; /* Permite que se ajusten en pantallas pequeñas */\n}\n\n.pedido-info {\n  margin-right: 20px; /* Espaciado entre los bloques de información */\n  text-align: left;\n  font-size: 14px;\n}\n\n.tipos-mcia-list {\n  margin: 0;\n  padding: 0;\n  list-style-type: none; /* Sin viñetas para la lista */\n}\n\n.tipos-mcia-list li {\n  display: inline;\n  margin-right: 10px; /* Espacio entre elementos */\n}\n\n/* --- Estilos Premium para Tabla de Historial --- */\n\n/* Permitir que los encabezados tengan varias líneas y centrar texto */\n.table-historico-nested .p-datatable .p-datatable-thead > tr > th {\n  white-space: normal !important;\n  text-align: center !important;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1.2;\n  padding: 8px 4px !important;\n  background: #f1f3f5 !important;\n  color: #495057;\n  border-bottom: 2px solid #dee2e6;\n  vertical-align: middle;\n}\n\n/* Estilo de celdas internas */\n.table-historico-nested .p-datatable .p-datatable-tbody > tr > td {\n  font-size: 12px;\n  padding: 6px 4px !important;\n  text-align: center;\n  white-space: nowrap; /* Evita que el contenido se amontone */\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.nested-table-title {\n  margin-bottom: 12px;\n  color: #2c3e50;\n  font-weight: 600;\n  border-left: 4px solid #3498db;\n  padding-left: 10px;\n}\n\n.table-historico-nested {\n  background: #ffffff;\n  border-radius: 6px;\n  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);\n  padding: 15px !important;\n  margin: 10px 0;\n}\n\n/* Forzar que la tabla ocupe el espacio restante */\n.full-height-table {\n  display: flex;\n  flex-direction: column;\n  height: 100%; /* Asegura ocupar el contenedor flex asignado */\n}\n\n/* Forzar que el wrapper (área de scroll) crezca */\n.full-height-table .p-datatable-wrapper {\n  flex-grow: 1;\n  height: auto !important; /* Sobrescribir estilos inline si es necesario */\n}\n\n/* Asegurar que el footer del diálogo no se colapse */\n.p-dialog-content {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
